import React, { memo } from 'react';

const SymptomOptions = () => {
  return (
    <div className="row text-center my-3 align-items-center">
      <div className="col-12 col-md-4 mb-2 mb-md-0 d-none d-md-block">
        <h5 className="fw-bold">
        Explore Symptoms
          <span className="ms-2 d-inline-block"></span>
        </h5>
      </div>
      <div className="col-12 col-md-4 mb-2 mb-md-0">
        <h5 className="fw-bold text-primary">
          Symptoms
          <span className="ms-2 d-inline-block"></span>
        </h5>
      </div>
      <div className="col-12 col-md-4 d-none d-md-block">
        <h5 className="fw-bold">
          Results
          {/* <span className="ms-2 d-inline-block"></span> */}
        </h5>
      </div>
    </div>
  );
};

export default memo(SymptomOptions);
